import React from "react";
import "./InputLoadingSpinner.css";

export const InputLoadingSpinner = (
  <div className="input-spinner loading"></div>
);
